export default "__VITE_ASSET__Chg2zeZu__"